// extracted by mini-css-extract-plugin
export default {"article":"Background_article__Sh5Rb","header":"Background_header__FeLx1","headersmtxt":"Background_headersmtxt__c9-6H"};